import React from 'react';
import './Footer.css';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="footer">
      <div className="container">
        {/* <div className="footer-content">
          <div className="footer-brand">
            <div className="footer-logo">JSW</div>
            <h3>Jay Street Workout & Calisthenics Studio</h3>
            <p>街頭及徒手健身專家</p>
          </div>
          
          <div className="footer-links">
            <h4>快速連結</h4>
            <ul>
              <li><a href="#home">主頁</a></li>
              <li><a href="#about">關於我們</a></li>
              <li><a href="#courses">課程</a></li>
              <li><a href="#trainers">教練</a></li>
              <li><a href="#contact">聯絡我們</a></li>
            </ul>
          </div>
          
          <div className="footer-contact">
            <h4>聯絡資訊</h4>
            <p>📍 香港九龍旺角彌敦道677號恒生旺角大廈7樓</p>
            <p>📱 +852 1234 5678</p>
            <p>📧 info@jaystreetworkout.com</p>
          </div>
          
          <div className="footer-social">
            <h4>關注我們</h4>
            <div className="social-icons">
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer">FB</a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer">IG</a>
              <a href="https://youtube.com" target="_blank" rel="noopener noreferrer">YT</a>
            </div>
          </div>
        </div> */}
        
        <div className="footer-bottom">
          <p>&copy; {currentYear} Jay Street Workout & Calisthenics Studio. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
